module.exports = __webpack_public_path__ + "static/media/logo-dark.40d29e5e.svg";